// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__BdAqo","vLegacy":"SelectSecondary_vLegacy__5K5v0","error":"SelectSecondary_error__Lh3n-","disabled":"SelectSecondary_disabled__2AgCv"};